/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_DocumentInputs */

const en_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading document...`)
};

const es_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo documento...`)
};

const fr_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload du document...`)
};

const de_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument wird hochgeladen...`)
};

const ja_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメントをアップロード中...`)
};

const zh_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传文档...`)
};

const ar_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري رفع المستند...`)
};

const id_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengunggah dokumen...`)
};

const it_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento documento...`)
};

const ru_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка документа...`)
};

const pt_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazendo upload do documento...`)
};

const ko_uploading_document = /** @type {(inputs: Uploading_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 업로드 중...`)
};

/**
* | output |
* | --- |
* | "Uploading document..." |
*
* @param {Uploading_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const uploading_document = /** @type {((inputs?: Uploading_DocumentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_DocumentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploading_document(inputs)
	if (locale === "es") return es_uploading_document(inputs)
	if (locale === "fr") return fr_uploading_document(inputs)
	if (locale === "de") return de_uploading_document(inputs)
	if (locale === "ja") return ja_uploading_document(inputs)
	if (locale === "zh") return zh_uploading_document(inputs)
	if (locale === "ar") return ar_uploading_document(inputs)
	if (locale === "id") return id_uploading_document(inputs)
	if (locale === "it") return it_uploading_document(inputs)
	if (locale === "ru") return ru_uploading_document(inputs)
	if (locale === "pt") return pt_uploading_document(inputs)
	return ko_uploading_document(inputs)
});